module.exports = __webpack_public_path__ + "img/surveying2.13ea863f.png";